module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-victoria.9f633668.jpg";